type PairingCodeDigitsProps = {
  code: string;
};

export function PairingCodeDigits({ code }: PairingCodeDigitsProps) {
  const digits = code.split('');

  return (
    <div className="pairing-code" aria-label={`Pairing code ${code}`}>
      {digits.map((digit, index) => (
        <span key={`${digit}-${index}`} className="pairing-code__cell">
          <span className="pairing-code__glyph">{digit}</span>
        </span>
      ))}
    </div>
  );
}
